import { Dimensions, Platform } from 'react-native';

export const useResponsiveStyles = () => {
  const screenWidth = Dimensions.get('window').width;
  const screenHeight = Dimensions.get('window').height;
  
  const isWeb = Platform.OS === 'web';
  const isMobile = Platform.OS !== 'web' || screenWidth < 768;
  const isTablet = !isWeb && screenWidth >= 768 && screenWidth < 1024;
  
  // Responsive dimensions
  const getResponsiveValue = (mobileValue: number, webValue?: number) => {
    if (isWeb) return webValue || mobileValue;
    return mobileValue;
  };
  
  // Grid columns based on screen size
  const getGridColumns = () => {
    if (isWeb) return 3; // Always 3 columns on web
    if (screenWidth < 400) return 1; // Single column on small mobile
    if (screenWidth < 600) return 2; // Two columns on mobile
    return 3; // Three columns on larger screens
  };
  
  // Responsive spacing
  const spacing = {
    xs: getResponsiveValue(4, 4),
    sm: getResponsiveValue(8, 8),
    md: getResponsiveValue(12, 16),
    lg: getResponsiveValue(16, 24),
    xl: getResponsiveValue(20, 32),
    xxl: getResponsiveValue(24, 40),
  };
  
  // Responsive font sizes
  const fontSize = {
    xs: getResponsiveValue(10, 12),
    sm: getResponsiveValue(12, 14),
    md: getResponsiveValue(14, 16),
    lg: getResponsiveValue(16, 18),
    xl: getResponsiveValue(18, 20),
    xxl: getResponsiveValue(20, 24),
    title: getResponsiveValue(22, 28),
  };
  
  // Card dimensions
  const cardWidth = isWeb ? 'auto' : screenWidth - (spacing.md * 2);
  const cardMinHeight = getResponsiveValue(120, 140);
  
  // Modal dimensions
  const modalWidth = isWeb ? 600 : screenWidth * 0.9;
  const modalMaxHeight = screenHeight * 0.8;
  
  // Input dimensions
  const inputHeight = getResponsiveValue(40, 44);
  
  // Button dimensions
  const buttonHeight = getResponsiveValue(44, 48);
  const iconSize = getResponsiveValue(18, 20);
  
  return {
    isWeb,
    isMobile,
    isTablet,
    screenWidth,
    screenHeight,
    spacing,
    fontSize,
    cardWidth,
    cardMinHeight,
    modalWidth,
    modalMaxHeight,
    inputHeight,
    buttonHeight,
    iconSize,
    getGridColumns,
    getResponsiveValue,
  };
};

// Helper function to create responsive styles
export const createResponsiveStyles = (
  mobileStyles: any,
  webStyles: any = {}
) => {
  const isWeb = Platform.OS === 'web';
  return isWeb ? { ...mobileStyles, ...webStyles } : mobileStyles;
};
